import { io } from "socket.io-client";
import { socketUrl } from "./shared/socketUrl";
import { TOKEN_KEY } from "./Utils/Constants";
import { checkEnvironment } from "./shared/baseUrl";

let socket = null;

const initializeSocket = async () => {
  if (!socket) {
    const user = localStorage.getItem("thrift-client-token");
    if (user) {
      socket = io(socketUrl, {
        auth: {
          token:
            localStorage.getItem(TOKEN_KEY) !== null
              ? "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
              : null,
          socketToken: checkEnvironment() === 'staging' ? 'LF07xwaRIxAGe6bEo3CDxsp0ZTIXJRyXwzfm' : "123456",
        },
        secure: true,
        transports: ["websocket"],
      });
    }
  }
  return socket;
};

export default initializeSocket;
